import CSR_PC from '@/components/CSR';
import CSR_H5 from '@/componentsH5/CSR';
import { redirectTo404 } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import PageLayout from '@/components/PageLayout';
import SEOlinksA from '@/components/SEOlinksA';
import seoconfig from '@/seoconfig/support-for-disaster-prevention';

export default function CSR({ SEO, lang }: any) {
    const { isMobile, useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('csr');
    const LayoutCom = isMobile ? CSR_H5 : CSR_PC;

    return (
        <PageLayout theme="black">
            <SEO title={lang?.title || t('secA_title')} />
            <SEOlinksA locale={locale} list={seoconfig.include} pathname={seoconfig.url} />
            <LayoutCom />
        </PageLayout>
    );
}

export async function getServerSideProps({ locale }: any) {
    if (locale !== 'jp') {
        return redirectTo404();
    }
    return {
        props: {},
    };
}
